import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slickBanner.css";
import Shimmer from '../../../component/Shimmer';
import apiClient from '../../../apiClient/apiClient';
import { useDispatch } from 'react-redux';
import { setFilters } from '../../../redux/auth/action/filtersActions';
import { Link } from 'react-router-dom';

function SlickBanner({ events }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  console.log("SlickBanner component rendered");

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: true,
    fade: false
  };

  useEffect(() => {
    console.log("Fetching images from API...");
    
    const fetchImages = async () => {
      try {
        // Remove the api/ prefix as it's likely included in the baseURL
        const response = await apiClient.get("/image-upload/");
        console.log("API Response:", response.data);
        
        if (response.data && response.data.results && response.data.results.length > 0) {
          const bannerData = response.data.results[0]; // Get first result
          console.log("Banner data:", bannerData);
          
          // Create array of all available images (even if some are null)
          const bannerImages = [
            bannerData.slider_1,
            bannerData.slider_2,
            bannerData.slider_3,
            bannerData.slider_4,
            bannerData.slider_5
          ].filter(url => url !== null && url !== ""); // Filter out null/empty values
          
          console.log("Filtered banner images:", bannerImages);
          
          if (bannerImages.length > 0) {
            setImages(bannerImages);
          } else {
            // Use defaults if no images found
            console.warn("No banner images found in API response");
            setImages([
              "https://via.placeholder.com/1200x400?text=Default+Banner+1",
              "https://via.placeholder.com/1200x400?text=Default+Banner+2"
            ]);
          }
        } else {
          console.warn("Invalid API response format");
          setImages([
            "https://via.placeholder.com/1200x400?text=Default+Banner+1",
            "https://via.placeholder.com/1200x400?text=Default+Banner+2"
          ]);
        }
      } catch (error) {
        console.error('Error fetching images:', error);
        setError(error.message);
        setImages([
          "https://via.placeholder.com/1200x400?text=Default+Banner+1",
          "https://via.placeholder.com/1200x400?text=Default+Banner+2"
        ]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchImages();
  }, []);

  const handleCategoryClick = (categoryName) => {
    dispatch(setFilters({ category: categoryName }));
  };

  if (loading) {
    return <Shimmer width="100%" height="400px" />;
  }

  // Always show the slider, even if events is empty
  return (
    <div className="banner-wrapper">
      {error && (
        <div style={{backgroundColor: "#fff3cd", padding: "10px", margin: "10px 0"}}>
          Error loading banner images. Check console for details.
        </div>
      )}
      
      <div className="banner-container">
        {images.length > 0 && (
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index} className="banner-slide">
                <div className="banner-content">
                  {index === 0 && (
                    <>
                      <h1 className="banner-title">
                        Connecting Communities, Celebrating Traditions
                      </h1>
                      <p className="banner-subtitle">
                        From Food Fests to Traditional Dance, Find It Here
                      </p>
                      <a href="https://play.google.com/store/apps/details?id=com.cubeqtec.eventsfullsundaysuser&hl=en" target="_blank" rel="noopener noreferrer">
                        <button
                          className="banner-cta-button"
                          onClick={() => handleCategoryClick('cultural')}
                        >
                          Download Mobile App
                        </button>
                      </a>
                    </>
                  )}
                  {index === 1 && (
                    <>
                      <h1 className="banner-title">
                      NEPATHYA LIVE IN LONDON
                      </h1>
                      <p className="banner-subtitle">
                      The Legends of Nepali Music | 
                      A Night of Soulful Rhythms & Unforgettable Hits
                      </p>
                      <Link to={`/event/184`}>
                        <button
                          className="banner-cta-button"
                          onClick={(e) => {
                            handleCategoryClick('music');
                          }}
                        >
                          Get Tickets Now!
                        </button>
                      </Link>
                    </>
                  )}
                  {index === 2 && (
                    <>
                      <h1 className="banner-title">
                      Not Just a Hackathon—It's a Proving Ground
                      </h1>
                      <p className="banner-subtitle">
                      Tech Moves Fast—So Should You
                      </p>
                      <Link to={`/event/173`}>
                        <button
                          className="banner-cta-button"
                          onClick={(e) => {
                            handleCategoryClick('Tech');
                          }}
                        >
                          Get Tickets Now!
                        </button>
                      </Link>
                    </>
                  )}
                  {/* Add content for banners 3 and 4 */}
                  {index === 3 && (
                    <>
                      <h1 className="banner-title">
                        Professional Growth
                      </h1>
                      <p className="banner-subtitle">
                        Learn, Network, Grow!
                      </p>
                      <a href="/register" className="banner-cta-link">
                        <button
                          className="banner-cta-button"
                          onClick={(e) => {
                            e.preventDefault();
                            handleCategoryClick('career');
                            window.location.href = "/register";
                          }}
                        >
                          Register Now
                        </button>
                      </a>
                    </>
                  )}
                  {index === 4 && (
                    <>
                      <h1 className="banner-title">
                        Festivals & Carnivals
                      </h1>
                      <p className="banner-subtitle">
                        Experience the Magic of Live Events
                      </p>
                      <Link to="/">
                        <button
                          className="banner-cta-button"
                          onClick={() => handleCategoryClick('festival')}
                        >
                          Find Events
                        </button>
                      </Link>
                    </>
                  )}
                </div>
                <div className="banner-image-container">
                  <img
                    src={image}
                    alt={`Event banner ${index + 1}`}
                    className="banner-image"
                    onError={(e) => {
                      console.error("Error loading image:", image);
                      e.target.src = "https://via.placeholder.com/1200x400?text=Image+Load+Failed";
                      e.target.onerror = null;
                    }}
                  />
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
}

export default SlickBanner;